import React from 'react';
import { useIntl } from 'react-intl';
import MediaQuery from 'react-responsive';
import { useSelector } from 'react-redux';

import styles from './Footer.module.css';
import { ReactComponent as FacebookIcon } from '../../assets/img/facebook-square.svg';
import { ReactComponent as TwitterIcon } from '../../assets/img/twitter-square.svg';
import { ReactComponent as YoutubeIcon } from '../../assets/img/youtube.svg';
import { ReactComponent as LinkedinIcon } from '../../assets/img/linkedin.svg';
import { ReactComponent as StudioIcon } from '../../assets/img/69F_logo.svg';

const Footer = () => {

  const { formatMessage } = useIntl();
  const currentYear = new Date().getFullYear();
  const { config: { links } } = useSelector(state => state.config);

  return (
    <div className={styles.container}>
      <MediaQuery minDeviceWidth={1224}>
        <div className={styles['horizontal-rule']}/>
      </MediaQuery>
      <div className={styles.wrapper}>
        <MediaQuery minDeviceWidth={1224}>
          <span className={`${styles.text} Rubik-20pt`}>
            {formatMessage({ id: 'Footer.copyright' }, { currentYear })}
          </span>
          <a className={`${styles.link} Rubik-20pt`} href={links.privacyPolicy} target="_blank" rel="noopener noreferrer">
            {formatMessage({id: 'Footer.privacyPolicy'})}
          </a>
          <a className={`${styles.link} Rubik-20pt`} href={links.cookiesPolicy} target="_blank" rel="noopener noreferrer">
            {formatMessage({id: 'Footer.cookiesPolicy'})}
          </a>
          <a className={`${styles.link} Rubik-20pt`} href={links.contacts} target="_blank" rel="noopener noreferrer">
            {formatMessage({id: 'Footer.contact'})}
          </a>
        </MediaQuery>
        <div className={styles['social-wrapper']}>
          <span className={`${styles.text} Rubik-20pt`}>
            {formatMessage({id: 'Footer.followUs'})}
          </span>
          <a href="https://www.facebook.com/pages/ASBIS/200468836642851" target="_blank" rel="noopener noreferrer">
            <FacebookIcon className={styles['social-icon']}/>
          </a>
          <a href="https://twitter.com/asbis_com" target="_blank" rel="noopener noreferrer">
            <TwitterIcon className={styles['social-icon']}/>
          </a>
          <a href="http://www.youtube.com/user/ASBISCMG" target="_blank" rel="noopener noreferrer">
            <YoutubeIcon className={styles['social-icon']}/>
          </a>
          <a href="https://www.linkedin.com/company/asbis/" target="_blank" rel="noopener noreferrer">
            <LinkedinIcon className={styles['social-icon']}/>
          </a>
          <a href="https://69floors.art/" target="_blank" rel="noopener noreferrer" title="Made with peculiar sparkles in">
            <StudioIcon className={styles['studio-icon']}/>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
